/* global axios */
import ApiClient from './ApiClient';

class LineStickerAPI extends ApiClient {
  constructor() {
    super('linestickers', { accountScoped: true });
  }

  sendSticker(conversationId, packageId, stickerId) {
    const url = `/api/v1/accounts/${this.accountIdFromRoute}/conversations/${conversationId}/linestickers`;
    return axios.post(url, {
      packageId,
      stickerId,
    });
  }
}

export default new LineStickerAPI();
